import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import { MarkNotificationsAsReadDocument, MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables } from "@/graphql/__generated__/graphql";

export default function useMarkNotificationsAsReadMutationHook() {
  const { t } = useTranslation(["toasts"]);

  const [markNotificationsAsReadMutation, { loading, error }] = useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(
    MarkNotificationsAsReadDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "mark-notifications-as-read-success",
          data: {
            title: t("toasts.marknotificationsasread"),
            type: "success",
          }
        });
      }
    });

  return {
    markNotificationsAsReadMutation,
    loading,
    error
  };
};
